"use client";
import { Button, Container, Typography } from "@mui/material";
import { MotionContainer, varBounce } from "@onair/minimal-ui/animate";
import { PageNotFoundIllustration } from "@onair/minimal-ui/assets/illustrations/index";
import { m } from "framer-motion";
import Link from "next/link";

interface NotfoundContainerProps {
	className?: string;
	title?: string;
	description?: React.ReactNode;
}
const NotfoundContainer: React.FC<NotfoundContainerProps> = ({
	className,
	title = "Oops! Chúng tôi không tìm thấy nội dung này.",
	description = (
		<>
			<Typography sx={{ color: "text.secondary" }}>
				Có thể đường dẫn đã sai hoặc nội dung đã hết hạn.
			</Typography>
			<Typography sx={{ color: "text.secondary" }}>
				Bạn có thể quay lại trang chủ hoặc thử tìm kiếm bằng từ khóa khác.
			</Typography>
		</>
	),
}) => {
	return (
		<MotionContainer>
			<m.div variants={varBounce().in}>
				<PageNotFoundIllustration
					// sx={{ my: { xs: 5, sm: 10 }, mx: "auto" }}
					className="mx-auto mb-6"
				/>
			</m.div>
			<m.div variants={varBounce().in}>
				<Typography variant="h3" sx={{ mb: 2 }}>
					{title}
				</Typography>
			</m.div>
			<m.div variants={varBounce().in} className="mb-6">
				{description}
			</m.div>
			<Button
				component={Link}
				href="/"
				size="large"
				variant="contained"
				color="primary"
			>
				Về trang chủ
			</Button>
		</MotionContainer>
	);
};
export default NotfoundContainer;
